<form [formGroup]="formGroup">
	<div class="grid-6 copo-container">
		<div class="grid-column-one-full card-info-block">
			<!-- First row -->
			<div class="call-off-infoentry-form-row">
				<!-- Customer call-off reference-->
				<div class="customer-calloff-reference">
					<mat-form-field *ngIf="editCustomerCalloffReference" floatLabel="always">
						<mat-label translate>ecall-off.customer-call-off-reference</mat-label>
						<input matInput formControlName="customerCalloffReference" type="text" spellcheck="false"
							autocomplete="off" maxlength="64" required>
						<mat-icon class="copo-orange-text-icon" matSuffix svgIcon="md:edit"></mat-icon>
						<mat-error translate>ecall-off.required</mat-error>
					</mat-form-field>
					<ng-container *ngIf="!editCustomerCalloffReference">
						<div class="card-content-label" translate>ecall-off.customer-call-off-reference</div>
						<div class="card-content-value">{{customerCalloffReference}}</div>
					</ng-container>
				</div>
				<!-- RDDC mode -->
				<div class="rdd-mode">
					<mat-form-field *ngIf="editRddMode" floatLabel="always">
						<mat-label translate>ecall-off.rdd-mode</mat-label>
						<mat-select required formControlName="rddMode">
							<mat-option *ngFor="let option of RDD_MODES" [value]="option">
								{{option}}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<ng-container *ngIf="!editRddMode">
						<div class="card-content-label" translate>ecall-off.rdd-mode</div>
						<div class="card-content-value">{{rddMode}}</div>
					</ng-container>
				</div>
				<!-- Copy to -->
				<div class="copy-to">
					<mat-form-field *ngIf="editCopyTo" floatLabel="always">
						<mat-label translate>ecall-off.copy-to</mat-label>
						<input matInput formControlName="copyTo" type="text" spellcheck="false" autocomplete="off">
						<mat-icon class="copo-orange-text-icon" matSuffix svgIcon="md:edit" [matTooltip]="'ecall-off.separate-email-addresses' | translate"></mat-icon>
						<mat-error translate>elink.invalid-email-format</mat-error>
					</mat-form-field>
					<div *ngIf="!editCopyTo" [matTooltip]="!copyTo || copyTo.trim() === '' ? UNDERSCORE : getTooltipText(copyTo)">
						<div class="card-content-label" translate>ecall-off.copy-to</div>
						<div class="card-content-value comment-block">{{!copyTo || copyTo.trim() === '' ? UNDERSCORE : copyTo}}</div>
					</div>
				</div>
			</div>
			<!-- Second row -->
			<div class="call-off-infoentry-simple-row">
				<!-- Total weight-->
				<span class="center-alignment total-weight">
					<div class="copo-request-text">{{totalWeight | copoNumber:'weight':'t'}}</div>
					<div class="copo-grey-text" translate>ecall-off.total-material-request</div>
				</span>
				<!-- Nb objects -->
				<span class="center-alignment nb-objects">
					<div class="copo-request-text">
						<span>{{nbOrderItems ?? 0}}</span>&nbsp;<span>{{ objectTranslationKey ?? '' | translate }}</span>
					</div>
					<div class="copo-grey-text" translate>eoffer.requested</div>
				</span>
			</div>
		</div>
	</div>
</form>